var React = require('react');

function WaveBottomRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-0.64117 0.34562c76.926 1.7276 90.845 17.343 127.44 39.042 29.52 17.505 30.055-37.564 86.463-39.042v56.047h-213.9z","fill":"#fff"}));
}

WaveBottomRight.defaultProps = {"width":"800","height":"200","preserveAspectRatio":"none","version":"1.1","viewBox":"0 0 211.67 52.917"};

module.exports = WaveBottomRight;

WaveBottomRight.default = WaveBottomRight;
